module.exports = __webpack_public_path__ + "img/blue-hourglass.d79218d1.gif";